import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, BookOpen, Loader2 } from "lucide-react";
import api from "../lib/api";
import { MathText } from "../components/MathText";
import { useT } from "../context/LanguageContext";
import TopBar from "../components/TopBar";

export default function Theory() {
  const { examId, topicId } = useParams();
  const navigate = useNavigate();
  const t = useT();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/exams/${examId}/theory/${topicId}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [examId, topicId]);

  if (err) return (
    <div className="space-bg min-h-screen flex flex-col items-center justify-center px-5 text-center">
      <p className="text-white/70 mb-4">{t("Errore nel caricare la teoria. Riprova.")}</p>
      <button onClick={() => navigate(`/exam/${examId}`)} className="px-6 py-3 rounded-2xl btn-neon font-heading font-bold bouncy">{t("Indietro")}</button>
    </div>
  );

  if (!data) return (
    <div className="space-bg min-h-screen flex flex-col items-center justify-center gap-3 text-white/70">
      <Loader2 size={36} className="animate-spin" style={{ color: "var(--cyan)" }} />
      {t("L'AI sta preparando la spiegazione...")}
    </div>
  );

  return (
    <div className="space-bg min-h-screen pb-20">
      <TopBar />
      <div className="max-w-2xl mx-auto px-4 pt-5">
        <button onClick={() => navigate(`/exam/${examId}`)} className="flex items-center gap-1 text-white/60 bouncy mb-4" data-testid="theory-back-btn">
          <ChevronLeft size={18} /> {t("Esame")}
        </button>
        <h1 className="font-heading font-black text-3xl tracking-tight flex items-center gap-2 mb-6">
          <BookOpen style={{ color: "var(--cyan)" }} /> {data.topic_name}
        </h1>
        <div className="space-y-4">
          {data.sections.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              className="glass rounded-3xl p-5" data-testid={`theory-section-${i}`}>
              <h2 className="font-heading font-bold text-lg tracking-tight mb-2" style={{ color: "var(--cyan)" }}>{s.heading}</h2>
              <div className="text-white/80 leading-relaxed text-sm"><MathText>{s.body}</MathText></div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
